import * as React from 'react';
const AvatarContext = React.createContext({});
export default AvatarContext;
